import { render, staticRenderFns } from "./PreventivaFinalPanel.vue?vue&type=template&id=18f1453e&scoped=true&"
import script from "./PreventivaFinalPanel.vue?vue&type=script&lang=js&"
export * from "./PreventivaFinalPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f1453e",
  null
  
)

export default component.exports